import React from 'react'
import { DateRangePicker } from 'react-date-range';
import { useState } from 'react';

export default function SSNPullModal(props) {
    const [emailRecipient, setEmailRecipient] = useState('');

    // Validate Email
    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    const handleSubmit = () => {
    console.log("calendarDates: ", calendarDates);
    console.log("emailRecipient: ", emailRecipient);
    // validate Email
    if (!isValidEmail(emailRecipient)) {
        alert("Please enter a valid email address.");
        return;
    }
    // Validate Date Range
    if (!calendarDates || !calendarDates[0] || !calendarDates[0].startDate || !calendarDates[0].endDate) {
        alert("Please select a date range.");
        return;
    }

    // Cereate payload to send to API
    const payload = {
        "emailRecipient": emailRecipient,
        "startDate": calendarDates[0].startDate.toLocaleDateString(),
        "endDate": calendarDates[0].endDate.toLocaleDateString(),
        "apiKey": process.env.REACT_APP_OTG_Logics_KEY,
    };
    // console.log("Payload: ", payload);

    // Format Endpoint and options
    const reqUrl = `${process.env.REACT_APP_QF_API}/${process.env.REACT_APP_OTG_ID}/report/ssn`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    };

    // Send Request
    // console.log("Request URL: ", reqUrl);
    alert("SSN Report Request Sent. Please Allow Time to Process And Email WIll Be Sent To: " + emailRecipient);
    // Hide Modal and make request
    props.toggleShowSSNModal()
    fetch(reqUrl, requestOptions);
};


    const [calendarDates, setCalendarDates] = useState(() => {
        const today = new Date();
        const monday = new Date(today);
        monday.setDate(today.getDate() - today.getDay() + 1); // Set to Monday of current week
        const friday = new Date(today);
        friday.setDate(today.getDate() - today.getDay() + 5); // Set to Friday of current week

        return [{
            startDate: monday,
            endDate: friday,
            key: 'selection'
        }];
    });

    return (
        <>
            <div className='whiteBg w-25 center rounded-5 m-top-3 ssnBoxPadding'>
                <div>
                    <button onClick={() => props.toggleShowSSNModal()} className='blueButton'>X</button>
                </div>
                <h4 className='center-text'>Pull SSN for Cases Created In Date Range</h4>
                <DateRangePicker
                    className=''
                    onChange={item => {
                        setCalendarDates([item.selection]);
                    }}
                    showSelectionPreview={true}
                    // moveRangeOnFirstSelection={false}
                    // retainEndDateOnFirstSelection={true}
                    months={1}
                    ranges={calendarDates}
                    direction="vertical"
                    editableDateInputs={true}
                    dateDisplayFormat="MM/dd/yyyy"
                />
                <div className='m-top-2'>
                    <label for='ssnReportEmail'>Email to Send Report To:</label>
                    <select onChange={(e) => setEmailRecipient(e.target.value)} className='m-left-2' name='ssnReportEmail' type='email' >
                        <option value=''>Select Email</option>
                        {/* Loop through props.adminList to add options */}
                        {props.adminList.map((email, index) => (
                            <option key={index} value={email}>
                                {email}
                            </option>
                        ))}
                    </select>
                </div>
                <div className='m-top-2 right-text'>
                    <button onClick={() => handleSubmit()} className='blueButton m-top-2'>Pull SSN </button>
                </div>
            </div>
        </>
    )
}
